import {
  modifyObj,
  getRegisterSMSVerifyCode,
  getLoginSMSVerifyCode,
  bindTelephone,
  registerAndLoginByWebApp,
} from '@/api/clientaccountserv'

export default {
  state: {
    state_ClientAccount_ModifyObjResult: null,
    state_ClientAccount_GetRegisterSMSVerifyCodeResult: null,
    state_ClientAccount_GetLoginSMSVerifyCodeResult: null,
    state_ClientAccount_BindTelephoneResult: null,
    state_ClientAccount_RegisterAndLoginByWebAppResult: null,
  },
  mutations: {
    SET_CLIENTACCOUNT_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_ClientAccount_ModifyObjResult = rst;
    },
    SET_CLIENTACCOUNT_GETREGISTERSMSVERIFYCODE_RESULT: (state, rst) => {
      state.state_ClientAccount_GetRegisterSMSVerifyCodeResult = rst;
    },
    SET_CLIENTACCOUNT_GETLOGINSMSVERIFYCODE_RESULT: (state, rst) => {
      state.state_ClientAccount_GetLoginSMSVerifyCodeResult = rst;
    },
    SET_CLIENTACCOUNT_BINDTELEPHONE_RESULT: (state, rst) => {
      state.state_ClientAccount_BindTelephoneResult = rst;
    },
    SET_CLIENTACCOUNT_REGISTERANDLOGINBYWEBAPP_RESULT: (state, rst) => {
      state.state_ClientAccount_RegisterAndLoginByWebAppResult = rst;
    },
  },
  actions: {
    ClientAccountServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENTACCOUNT_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENTACCOUNT_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientAccountServ_GetRegisterSMSVerifyCode({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRegisterSMSVerifyCode(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENTACCOUNT_GETREGISTERSMSVERIFYCODE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENTACCOUNT_GETREGISTERSMSVERIFYCODE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientAccountServ_GetLoginSMSVerifyCode({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getLoginSMSVerifyCode(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENTACCOUNT_GETLOGINSMSVERIFYCODE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENTACCOUNT_GETLOGINSMSVERIFYCODE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientAccountServ_BindTelephone({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindTelephone(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENTACCOUNT_BINDTELEPHONE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENTACCOUNT_BINDTELEPHONE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ClientAccountServ_RegisterAndLoginByWebApp({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        registerAndLoginByWebApp(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CLIENTACCOUNT_REGISTERANDLOGINBYWEBAPP_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CLIENTACCOUNT_REGISTERANDLOGINBYWEBAPP_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_ClientAccount_ModifyObjResult: state => {
      return state.state_ClientAccount_ModifyObjResult;
    },
    get_ClientAccount_GetRegisterSMSVerifyCodeResult: state => {
      return state.state_ClientAccount_GetRegisterSMSVerifyCodeResult;
    },
    get_ClientAccount_GetLoginSMSVerifyCodeResult: state => {
      return state.state_ClientAccount_GetLoginSMSVerifyCodeResult;
    },
    get_ClientAccount_BindTelephoneResult: state => {
      return state.state_ClientAccount_BindTelephoneResult;
    },
    get_ClientAccount_RegisterAndLoginByWebAppResult: state => {
      return state.state_ClientAccount_RegisterAndLoginByWebAppResult;
    },
  }
}